import { render, staticRenderFns } from "./Wills.vue?vue&type=template&id=57f0e9ed"
import script from "./Wills.vue?vue&type=script&lang=js"
export * from "./Wills.vue?vue&type=script&lang=js"
import style0 from "./Wills.vue?vue&type=style&index=0&id=57f0e9ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports